<template>
  
</template>
<script>
import { infoPage, remove } from "@/api/pick/index";
import store from '@/store';

export default {
  data() {
    return {
      
    }
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>
<style></style>
@/api/subject/index